import {applyMiddleware, combineReducers, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import thunk from "redux-thunk";
import {authReducer} from "./reducers/Auth.Reducer";
import {cartReducer} from "./reducers/Cart.Reducer";
import {
  accountReducer,
  BookingReducer,
  customerReducer,
  DashboardReducer,
  inventoryReducer,
  restaurantReducer,
  SalesPurchaseReducer,
  StockReducer,
  utilitiesReducer,
} from "./reducers/Modules.Reducer";
import {productReducer} from "./reducers/Product.Reducer";
import {socketReducer} from "./reducers/Socket.Reducer";

const rootReducer = combineReducers({
  Products: productReducer,
  Cart: cartReducer,
  Auth: authReducer,
  Inventory: inventoryReducer,
  Utilities: utilitiesReducer,
  Restaurant: restaurantReducer,
  Customer: customerReducer,
  Accounts: accountReducer,
  SalesPurchase: SalesPurchaseReducer,
  Booking: BookingReducer,
  Dashboard: DashboardReducer,
  Stock: StockReducer,
  Socket: socketReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;